var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history"},[_c('div',{staticClass:"bar-chart"},[_c('BarChart',{attrs:{"id":"historicChartId","chart-data":_vm.dataCollection,"options":_vm.options}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }